module.exports = __webpack_public_path__ + "7ffcf5936d2287f685de86688a2c559f.svg";